module.exports = __webpack_public_path__ + "img/header-engagementRingsWhitegold@2x.fe660ee.webp";